import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class PointsCloud extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.plus = this.game.make.text(0, 0, '+', {
      font: '106px ' + this.game.titleFontStyle,
      fill: '#ff00ff',
    });
    this.plus.anchor.set(1, 0.5);
    this.plus.setShadow(0, 5, 'rgba(0,0,0,0.25)');
    this.addChild(this.plus);

    this.one = this.game.make.text(0, 0, '1', {
      font: '132px ' + this.game.titleFontStyle,
      fill: '#ff00ff',
    });
    this.one.anchor.set(0, 0.5);
    this.one.setShadow(0, 5, 'rgba(0,0,0,0.25)');
    this.addChild(this.one);

    this.angle = -6;
    this.scale.set(0);
    //
    let tween = this.game.add
      .tween(this)
      .to({ y: '-50' }, 100)
      .to({ y: '-20' }, 500)
      .to({ y: '-200', alpha: 0 }, 100);
    tween.start();
    tween = this.game.add
      .tween(this.scale)
      .to({ x: 1, y: 1 }, 100)
      .to({ y: 1 }, 500)
      .to({ x: 1.1, y: 1.1 }, 100);
    tween.onComplete.add(this.destroy, this);
    tween.start();

    this.game.sounds.playSpriteSFX('correct', { spriteID: 'game_audiosprite' });
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ui/PointsCloud.js